import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const faqs = [
  ["Where do you ship?", "Within India only, for now — and shipping is free. Your envelope comes straight to your doorstep."],
  ["What plans can I choose from?", "Four subscriptions: Monthly (₹444 every month), three months (₹1,111), six months (₹2,222) and a whole year (₹4,444). Each brings one envelope a month and renews automatically on Razorpay at the end of its period. Or choose a one-time envelope for ₹555, with no renewal."],
  ["How does subscribing work?", "Pick a plan, share your shipping address with us, then complete your subscription on Razorpay. A new themed envelope is posted to you every month."],
  ["Can I send one as a gift?", "Yes! The one-time envelope (₹555) makes a lovely gift. Add the recipient's name and address in the form, plus a little note for them."],
  ["Do I need to do anything with it?", "Not at all. No homework. No pressure. Open it slowly and enjoy it at your own pace."],
];

export const Faq = () => (
  <section id="faq" className="py-28" data-testid="faq-section">
    <div className="max-w-3xl mx-auto px-6">
      <h2 className="font-serif-display text-3xl sm:text-4xl lg:text-5xl text-stone-900">Little questions</h2>
      <Accordion type="single" collapsible className="mt-10">
        {faqs.map(([q, a], i) => (
          <AccordionItem key={q} value={`q${i}`}>
            <AccordionTrigger className="font-serif-display text-xl text-left hover:no-underline" data-testid={`faq-trigger-${i}`}>{q}</AccordionTrigger>
            <AccordionContent className="text-stone-600 text-base leading-relaxed">{a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);
